<!-- First page that unauthenticated users see in the app wrappers. -->

<template>
  <v-layout
    column
    fill-height
    align-center
  >
    <!-- Header Image -->
    <img
      :src="wifiSetupHeaderUrl"
      width="100%"
      height="auto"
      style="max-width: 600px"
      class="my-3"
    >
    <!-- Step 1 -->
    <div class="mt-1 text-xs-center">
      <div
        class="font-weight-bold grey--text text--lighten-2 my-3"
        style="font-size: 2.5em"
      >
        1
      </div>
      <div class="subheading white--text">
        MYSHOPRADIO+TV App downloaden, installieren und starten.
      </div>
      <div class="subheading grey--text text--lighten-1 mt-3">
        Download, install and launch the MYSHOPRADIO+TV App.
      </div>
      <div class="mt-3">
        <a
          href="https://itunes.apple.com/de/app/myshopradio/id1371468674?mt=8"
          target="_blank"
          style="margin-right: 10px"
        >
          <img
            src="https://cms.myshopradio.de/static/appstore_ios_48.png"
          ></a>
        <a
          href="https://play.google.com/store/apps/details?id=de.myshopradio.app_wrapper"
          target="_blank"
        >
          <img
            src="https://cms.myshopradio.de/static/appstore_googleplay_48.png"
          ></a>
      </div>
    </div>
    <hr class="full-width mt-3 grey">
    <!-- Step 2 -->
    <div class="text-xs-center">
      <div
        class="font-weight-bold grey--text text--lighten-2 my-3"
        style="font-size: 2.5em"
      >
        2
      </div>
      <div class="subheading white--text">
        Öffne die MYSHOPRADIO+TV App und gehe im Menü zu → VERWALTUNG → GERÄTE
      </div>
      <div class="subheading grey--text text--lighten-1 mt-3">
        Open the menu and navigate to → ADMINISTRATION → Equipment
      </div>
    </div>
    <hr class="full-width mt-3 grey">
    <!-- Step 3 -->
    <div class="text-xs-center">
      <div
        class="font-weight-bold grey--text text--lighten-2 my-3"
        style="font-size: 2.5em"
      >
        3
      </div>
      <div class="subheading white--text">
        Klicke auf → "WIFI AUF NEUEM PLAYER EINRICHTEN"
      </div>
      <div class="subheading grey--text text--lighten-1 mt-3">
        Click on → "SETUP WIFI ON NEW PLAYER"
      </div>
      <img
        class="mt-3"
        :src="configureWifiButtonUrl"
        width="100%"
        style="max-width: 320px"
        height="auto"
      >
    </div>
    <hr class="full-width mt-3 grey">
    <!-- Step 4 -->
    <div class="text-xs-center">
      <div
        class="font-weight-bold grey--text text--lighten-2 my-3"
        style="font-size: 2.5em"
      >
        4
      </div>
      <div class="subheading white--text">
        Halte dich in unmittelbarer Nähe des TV-Players auf und wähle den
        passenden TV-Player aus.
      </div>
      <div class="subheading grey--text text--lighten-1 mt-3">
        Keep close to the player you want to setup and choose the right one.
      </div>
      <img
        class="mt-4 dark-image-border"
        :src="iosWifiSetupChoosePlayerUrl"
        width="100%"
        style="max-width: 320px"
        height="auto"
      >
    </div>
    <hr class="full-width mt-3 grey">
    <!-- Step 5 -->
    <div class="text-xs-center">
      <div
        class="font-weight-bold grey--text text--lighten-2 my-3"
        style="font-size: 2.5em"
      >
        5
      </div>
      <div class="subheading white--text">
        Wähle dein WLAN aus, mit dem der TV-Player verbunden werden soll und
        halte das dazugehörige Passwort bereit.
      </div>
      <div class="subheading grey--text text--lighten-1 mt-3">
        Choose the WLAN for your player and hold your password ready for
        configuration.
      </div>
      <img
        class="mt-4 dark-image-border"
        :src="iosWifiSetupChooseNetworkUrl"
        width="100%"
        style="max-width: 320px"
        height="auto"
      >
    </div>
    <hr class="full-width mt-3 grey">
    <!-- Step 6 -->
    <div class="text-xs-center">
      <div
        class="font-weight-bold grey--text text--lighten-2 my-3"
        style="font-size: 2.5em"
      >
        6
      </div>
      <div class="subheading white--text">
        Nach erfolgreicher Einrichtung ist der TV-Player sofort erreichbar.
      </div>
      <div class="subheading grey--text text--lighten-1 mt-3">
        On successful configuration the player will be reachable immediately.
      </div>
      <img
        class="mt-4 dark-image-border"
        :src="iosWifiSetupConnectedUrl"
        width="100%"
        style="max-width: 240px"
        height="auto"
      >
    </div>
    <hr class="full-width mt-3 grey">
    <!-- Questions? -->
    <div class="text-xs-center my-3">
      <div class="subheading white--text">
        Noch Fragen?
      </div>
      <div class="subheading grey--text text--lighten-1 mt-3">
        Any questions?
      </div>
      <div class="subheading white--text mt-3">
        <a
          href="email:support@myshopradio.de"
          class="white--text"
        >support@myshopradio.de</a><br>
        <a
          href="tel:+49(0)5211639270"
          class="white--text"
        >Telefon +49(0)521 163 927 0</a>
      </div>
    </div>
  </v-layout>
</template>

<script>
export default {
  computed: {
    wifiSetupHeaderUrl() {
      return 'https://cms.myshopradio.de/filer/canonical/1652878999/878/';
    },
    configureWifiButtonUrl() {
      return 'https://cms.myshopradio.de/filer/canonical/1652880225/879/';
    },
    iosWifiSetupChoosePlayerUrl() {
      return 'https://cms.myshopradio.de/filer/canonical/1652880395/880/';
    },
    iosWifiSetupChooseNetworkUrl() {
      return 'https://cms.myshopradio.de/filer/canonical/1652880670/881/';
    },
    iosWifiSetupConnectedUrl() {
      return 'https://cms.myshopradio.de/filer/canonical/1652880833/882/';
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit('SET_SHOW_DRAWER', false);
    });
  },
};
</script>

<style scoped>
.dark-image-border {
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 6px;
  box-shadow: 2px 2px 0px 0px rgba(255, 255, 255, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/pages/WifiSetup.vue